import Alpine from "alpinejs";
import buyButton from "../alpine/buyButton";
import checkout from "../alpine/checkout";
import forgotPassword from "../alpine/forgotPassword";
import miniCart from "../alpine/miniCart";
import resetPassword from "../alpine/resetPassword";
import scrollSlider from "../alpine/scrollSlider";
import { miniCartStore } from "../alpine/store/miniCartStore";

declare global {
	interface Window {
		Alpine: typeof Alpine;
	}
}

window.Alpine = Alpine;

Alpine.store("cart", miniCartStore);

Alpine.data("scrollSlider", scrollSlider);
Alpine.data("buyButton", buyButton);
Alpine.data("checkout", checkout);
Alpine.data("resetPassword", resetPassword);
Alpine.data("forgotPassword", forgotPassword);
Alpine.data("miniCart", miniCart);
Alpine.start();
